module.exports = __webpack_public_path__ + "img/order.bccd68a2.png";